<section class="soon-panel" [class.bare]="bare">
  @if (title) {
    <header class="soon-head">
      <h3>{{ title }}</h3>
      @if (subtitle) {
        <p>{{ subtitle }}</p>
      }
    </header>
  }
  <div class="soon-body" [style.min-height.px]="height">
    <span class="material-symbols-outlined">{{ icon }}</span>
    <span class="soon-badge">Coming soon</span>
  </div>
</section>
